module.exports = __webpack_public_path__ + "img/Templates copy.5d99c96f.svg";